import React from 'react';
import { AppWidth, DocWidth, Flex, Span } from '@tpr/core';
import styles from './highlight.module.scss';
export var Highlight = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Scheme return' : _b, _c = _a.name, name = _c === void 0 ? '' : _c, _d = _a.psr, psr = _d === void 0 ? '' : _d;
    return (React.createElement(DocWidth, { className: styles.highlight },
        React.createElement("div", { className: styles.leftBackground }),
        React.createElement(AppWidth, { className: styles.highlightContent },
            React.createElement(Flex, { cfg: { flex: '0 0 auto' }, className: styles.schemeReturn },
                React.createElement(Span, { cfg: {
                        fontWeight: 4,
                        fontSize: 3,
                        lineHeight: 5,
                        color: 'white',
                        ml: 6,
                    } }, title)),
            React.createElement(Flex, { cfg: {
                    flex: '1 1 auto',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                } },
                React.createElement(Span, { cfg: {
                        fontWeight: 4,
                        fontSize: 3,
                        lineHeight: 5,
                        px: 4,
                        color: 'white',
                    }, className: styles.truncate }, name),
                React.createElement(Flex, { cfg: {
                        flex: '0 0 auto',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                    }, className: styles.psrNumber },
                    React.createElement("div", { className: styles.separator }),
                    React.createElement(Span, { cfg: {
                            fontWeight: 4,
                            fontSize: 3,
                            lineHeight: 6,
                            color: 'white',
                            px: 6,
                        } },
                        "PSR: ",
                        psr))))));
};
//# sourceMappingURL=highlight.js.map